import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {ReporteEstadoComponent} from './components/reporte.estado.component';
import {ReporteDashboardComponent} from './components/reporte.dashboard.component';
import {ReporteHoySemanaComponent} from './components/reporte.hoy.semana.component';
import {ReporteComparativoDashboardComponent} from './components/reporte.comparativo.dashboard.component';
import {ReporteRegionalDashboardComponent} from './components/reporte.regional.dashboard.component';
import {ReporteMarcasComponent} from './components/reporte.marcas.component';
import {ReporteMarcasColaboradorComponent} from './components/reporte.marcas.colaborador.component';
import {ReporteMarcasRegionalComponent} from './components/reporte.marcas.regional.component';
import {ReporteMarcasGeneralRegionalComponent} from './components/reporte.marcas.general.regional.component';
import {ReporteInventarioCategoriaComponent} from './components/reporte.inventario.categoria.component';
import {ReporteProddescPrecioventaComponent} from './components/reporte.proddesc.precioventa.component';
import {ReporteInventarioPrecioventComponent} from './components/reporte.inventario.preciovent.component';
import {EditMarcasComponent, MarcasCrudComponent, NewMarcasComponent} from './components/marcas/marcas.crud.component';


const appRoutes: Routes = [
  {path: 'reportes/estado', component: ReporteEstadoComponent},
  {path: 'reportes/semana', component: ReporteHoySemanaComponent},
  {path: 'reportes/dashboard', component: ReporteDashboardComponent},
  {path: 'reportes/comparativo', component: ReporteComparativoDashboardComponent},
  {path: 'reportes/regional', component: ReporteRegionalDashboardComponent},
  {path: 'reportes/marcas', component: ReporteMarcasComponent},
  {path: 'reportes/marcasRegGen', component: ReporteMarcasGeneralRegionalComponent},
  {path: 'reportes/marcasPar', component: ReporteMarcasColaboradorComponent},
  {path: 'reportes/marcasReg', component: ReporteMarcasRegionalComponent},
  {path: 'reportes/invxcat', component: ReporteInventarioCategoriaComponent},
  {path: 'reportes/descVentPub', component: ReporteProddescPrecioventaComponent},
  {path: 'reportes/invVentPub', component: ReporteInventarioPrecioventComponent},
  {path: 'admin/rankingmarcas', component: MarcasCrudComponent},
  {path: 'admin/rankingmarcas/edit/:id', component: EditMarcasComponent},
  {path: 'admin/rankingmarcas/new', component: NewMarcasComponent}
];


@NgModule({
  imports: [RouterModule.forChild(appRoutes)],
  exports: [RouterModule]
})
export class ReportesRoutingModule {
}
